import BlogClassicInner from "../components/BlogClassicInner";
import Breadcrumb from "../components/Breadcrumb";
import CertificateOne from "../components/CertificateOne";
import FooterOne from "../components/FooterOne";
import HeaderOne from "../components/HeaderOne";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";

const BlogClassicPage = () => {
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderOne */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb title={"Blog Classic"} />

      {/* BlogClassicInner */}
      <BlogClassicInner />

      {/* CertificateOne */}
      <CertificateOne />

      {/* FooterOne */}
      
    </>
  );
};

export default BlogClassicPage;
